<div class="w-full">
    <div *ngIf="component.showSearch">
        <app-search-box [component]="component" [entity]="page || job"></app-search-box>
    </div>
    <app-jobs-list *ngIf="!component.hideJobs" [jobs]="jobs" [component]="component" [loading]="loading" [entity]="page || job"></app-jobs-list>
</div>
